import AudioGrey from 'public/assets/audio_grey.svg';
import ThreeDGrey from 'public/assets/cube3d_grey.svg';
import DocsGrey from 'public/assets/doc_grey.svg';
import FolderActive from 'public/assets/folders.svg';
import ImageGrey from 'public/assets/image_grey.svg';
import VideoGrey from 'public/assets/video_grey.svg';

export const getDirectoryIcon = (d: string) => {
  if (d === 'Images') return ImageGrey.src;
  if (d === 'Audio') return AudioGrey.src;
  if (d === 'Videos') return VideoGrey.src;
  if (d === '3D') return ThreeDGrey.src;
  if (d === 'root') return FolderActive.src;
  return DocsGrey.src;
};
